import { BubbleChartPopovers } from '@ardoq/bubble-chart';
import { Notifier } from '@ardoq/dropdown-menu';
import { Stack } from '@ardoq/layout';
import { Link } from '@ardoq/link';
import { t, type I18nLocale, type WithI18nLocale } from '@ardoq/i18n';
import { type MouseEvent } from 'react';
import { openViewSettingsPanel } from 'viewSettings/openViewSettingsPanel';

type I18nLocaleArgs = WithI18nLocale;

// #region Popover components

type DisabledZoomToQuadrantPopoverContentProps = I18nLocaleArgs & {
  onLinkClick: (event: React.MouseEvent) => void;
};
const DisabledZoomToQuadrantPopoverContent = ({
  i18nLocale,
  onLinkClick,
}: DisabledZoomToQuadrantPopoverContentProps) => (
  <Stack>
    <span>
      {t(
        i18nLocale,
        'tabview:bubbleChart.noQuadrantsInLayout',
        'No quadrants in the layout.'
      )}
    </span>
    <Link hideIcon onClick={onLinkClick}>
      {t(i18nLocale, 'tabview:bubbleChart.changeLayout', 'Change layout')}
    </Link>
  </Stack>
);

// #endregion

// #region popover factory helpers

type CreateBubbleChartPopoversOptions = {
  /** Optional custom link-click handler for the "disabled zoom to quadrant" popover. */
  disabledZoomToQuadrantOnLinkClick?: (event: MouseEvent) => void;
  /** Optional notifier wired to the "select background" button. */
  selectBackgroundNotifier?: Notifier;
};

/**
 * Creates a full `BubbleChartPopovers` object whose factories close over
 * `i18nLocale`, so translated strings are resolved at render time without
 * reading `i18nLocale$.state` inside the components.
 */
export const createBubbleChartPopovers = (
  i18nLocale: I18nLocale,
  {
    disabledZoomToQuadrantOnLinkClick = openViewSettingsPanel,
    selectBackgroundNotifier,
  }: CreateBubbleChartPopoversOptions = {}
): BubbleChartPopovers => ({
  disabledZoomToQuadrantPopover: {
    selectBackgroundNotifier,
    popoverContent: (
      <DisabledZoomToQuadrantPopoverContent
        i18nLocale={i18nLocale}
        onLinkClick={disabledZoomToQuadrantOnLinkClick}
      />
    ),
  },
});

// #endregion
